module.exports = __webpack_public_path__ + "static/media/base_santinho.7f651938.png";